<template>
  <div class="" testek="product-detail">
    <div class="header"></div>
    <BaseDetail
      @viewDetail="viewDetail"
      @addData="addData"
      @addMoreData="addMoreData"
      :currentItem="currentItem"
      :titleDetail="$t('i18nCommon.TitleSupplierId')"
    >
      <template #header>
        <div class="font-bold text-xl mb-4">
          {{ title }}
        </div>
      </template>
      <template #content>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <a-form-item
                prop="Id"
                testek="Id"
                class="columns-1 w-full"
                v-if="mode == $enum.Mode.Edit"
              >
                <div class="flex">
                  <div class="font-bold min-w-32">
                    ID
                    <span class="ml-1 text-red-700">*</span>
                  </div>
                  <a-input v-model:value="ruleForm.id" />
                </div>
              </a-form-item>
              <div class="flex columns-1">
                <a-form-item prop="supName" testek="supName" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.supName" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="supPhone" testek="supPhone" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.supPhone" />
                  </div>
                </a-form-item>
                <a-form-item prop="supContactName" testek="supContactName" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Contact") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.supContactName" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="supCountry" testek="supCountry" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Conutry") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.supCountry" />
                  </div>
                </a-form-item>
                <a-form-item prop="supCity" testek="supCity" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.City") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.supCity" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="supAddress" testek="supAddress" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Address") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-textarea v-model:value="ruleForm.supAddress" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="supPostalCode" testek="supPostalCode" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.PostalCode") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.supPostalCode" />
                  </div>
                </a-form-item>
              </div>
              <a-form-item class="mt-6">
                <div class="flex">
                  <a-button
                    type="primary"
                    testek="btn-add"
                    @click="submitForm()"
                    class="mr-4"
                  >
                    {{ $t("i18nCommon.Add") }}
                  </a-button>
                  <a-button type="primary" testek="btn-add-more" @click="addMoreData()">
                    {{ $t("i18nCommon.AddMore") }}
                  </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </template>
    </BaseDetail>
    <div v-if="isShow && supplier">
      <a-modal v-model:open="isShow" centered :width="800" :closable="false">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Supplier") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <div class="flex columns-2">
                <a-form-item prop="name" testek="name" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                    </div>
                    <a-input v-model:value="supplier.supName" :disabled="true" />
                  </div>
                </a-form-item>
                <!-- <a-form-item prop="status" testek="status" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Status") }}
                    </div>
                    <a-input v-model:value="supplier.status" :disabled="true" />
                  </div>
                </a-form-item> -->
              </div>
              <div class="flex columns-2">
                <a-form-item prop="phone" testek="phone" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                    </div>
                    <a-input v-model:value="supplier.supPhone" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="contact" testek="contact" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Contact") }}
                    </div>
                    <a-input v-model:value="supplier.supContactName" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="conutry" testek="conutry" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Conutry") }}
                    </div>
                    <a-input v-model:value="supplier.supCountry" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="city" testek="city" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.City") }}
                    </div>
                    <a-input v-model:value="supplier.supCity" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="address" testek="address" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Address") }}
                    </div>
                    <a-textarea v-model:value="supplier.supAddress" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="postalCode" testek="postalCode" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.PostalCode") }}
                    </div>
                    <a-input v-model:value="supplier.supPostalCode" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { ModuleSupplier } from "@/store/module-const";
import BaseDetail from "@/views/base/BaseDetail.vue";
import { mapActions } from "vuex";
import _ from "lodash";
export default {
  name: "SupplierDetail",
  components: {
    BaseDetail,
  },
  props: {},
  computed: {
    title() {
      if (this.mode == this.$enum.Mode.Edit) return this.$t("i18nCommon.EditSupplier");
      return this.$t("i18nCommon.AddSupplier");
    },
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      contacts: [],
      statuses: [],
      currentItem: {},
      supplier: {},
      isShow: false,
      mode: this.$enum.Mode.Add,
    };
  },
  created() {
    const me = this;
    me.initDataStatic();
    me.$emitter.on("LoadEditSupplier", me.loadDataEdit);
  },
  beforeDestroy() {
    const me = this;
    me.$emitter.off("LoadEditSupplier", me.loadDataEdit);
  },
  methods: {
    ...mapActions(ModuleSupplier, ["createSupplier", "getSupplier", "updateSupplier"]),
    initDataStatic() {
      const me = this;
      me.rules = {
        status: [
          {
            required: true,
            message: `${me.$t("i18nProduct.StatusInvalid")}`,
            trigger: ["change", "blur"],
          },
        ],
        supContactName: [
          {
            required: true,
            message: `${me.$t("i18nProduct.ContactInvalid")}`,
            trigger: "blur",
          },
        ],
        supPhone: [
          {
            required: true,
            message: `${me.$t("i18nProduct.PhoneInvalid")}`,
            trigger: "blur",
          },
        ],
        supName: [
          {
            required: true,
            message: `${me.$t("i18nProduct.NameInvalid")}`,
            trigger: "blur",
          },
        ],
        supAddress: [
          {
            required: true,
            message: `${me.$t("i18nProduct.AddressInvalid")}`,
            trigger: "blur",
          },
        ],
        supCity: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CityInvalid")}`,
            trigger: "blur",
          },
        ],
        supPostalCode: [
          {
            required: true,
            message: `${me.$t("i18nProduct.PostalCodeInvalid")}`,
            trigger: "blur",
          },
        ],
        supCountry: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CountryInvalid")}`,
            trigger: "blur",
          },
        ],
        supPhone: [
          {
            required: true,
            message: `${me.$t("i18nProduct.PhoneNumberInvalid")}`,
            trigger: "blur",
          },
        ],
      };
      me.statuses = this.$config.StatusInfos;
    },
    loadDataEdit: _.debounce(async function (payload) {
      const me = this;
      if (!payload) return;
      me.mode = payload.mode;
      setTimeout(async () => {
        let supplier = await me.getSupplier({ id: payload.id });
        if (supplier) {
          me.ruleForm = {
            id: supplier.id,
            supName: supplier.supName,
            supContactName: supplier.supContactName,
            supAddress: supplier.supAddress,
            supCity: supplier.supCity,
            supPostalCode: supplier.supPostalCode,
            supCountry: supplier.supCountry,
            supPhone: supplier.supPhone,
          };
        }
      }, 300);
    }, 300),
    async submitForm(isReset = true) {
      const me = this;
      let formEl = me.$refs.ruleFormRef;
      if (!formEl) return;

      formEl
        .validate()
        .then(async () => {
          if (me.mode == me.$enum.Mode.Edit) {
            await me.editData();
          } else {
            await me.addData(isReset);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onChangeStatus(payload) {
      const me = this;
      let status = me.statuses.find((x) => x.id == payload);
      if (status) {
        me.ruleForm.status = status.id;
      }
    },

    addMoreData: _.debounce(async function () {
      const me = this;
      await me.submitForm(false);
    }, 300),
    addData: _.debounce(async function (isReset = true) {
      const me = this;
      let result = await me.createSupplier(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddSupplierSuccess")
        );
        if (isReset == true) {
          me.ruleForm = {};
        }
        // me.$router.push("/product");
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nProduct.AddSupplierFail"),
          "warning"
        );
      }
    }, 300),
    editData: _.debounce(async function () {
      const me = this;
      let result = await me.updateSupplier(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditSupplierSuccess")
        );
        me.ruleForm = {};
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditSupplierFail"),
          "warning"
        );
      }
    }, 300),

    viewDetail: _.debounce(async function (params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.supplier = await me.getSupplier({ id: params.id });
      if (me.supplier) {
        me.isShow = true;
      } else {
      }
      //Show form chi tiết
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
